export default {
    cover: {
        text: 'Pronađi svoju uslugu',
        button: 'ISTRAŽI',
        no_offers: 'Trenutno nema usluga za odabranu kategoriju',
        show_all: 'Prikaži sve',
    },
    widget: {
        book_experience: 'Istraži nova iskustva',
        top_companies: 'Najbolje kompanije',
        find_offers: 'Pronađi usluge',
    },
    subdomain: {
        popular_offer: 'Najpopularnije usluge',
        show_more: 'Prikaži sve',
    },
}
